module.exports = __webpack_public_path__ + "assets/img/four.e1f07662.png";